import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const ImessageScaleMedium = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12 3C9.34784 3.00002 6.80431 3.88202 4.92895 5.45199C3.05359 7.02196 2.00002 9.1513 2 11.3716C2.00242 12.8158 2.45106 14.2348 3.30234 15.4909C4.15361 16.747 5.37856 17.7974 6.85813 18.54C6.46407 19.4267 5.87305 20.2582 5.10956 21C6.59015 20.7388 7.98002 20.19 9.17098 19.3964C10.0893 19.6248 11.042 19.7416 12 19.7432C14.6522 19.7431 17.1957 18.8611 19.0711 17.2912C20.9464 15.7212 22 13.5918 22 11.3716C22 9.1513 20.9464 7.02196 19.071 5.45199C17.1957 3.88202 14.6522 3.00002 12 3Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Imessage'
);
export default ImessageScaleMedium;
